import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card, Tab, Nav, Button } from "react-bootstrap";
import { PersonBadge, Table, Send, ArrowLeft } from "react-bootstrap-icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import paths from "routes/paths";
import { useDispatch, useSelector } from "react-redux";
import { GetSingleEligibilityData } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import { toast } from "react-toastify";
import Flex from "components/common/Flex";
import FalconComponentCard from "components/common/FalconComponentCard";

// const TabTitle = ({ title, icon, isActive }) => (
//   <Flex className="align-items-center gap-2">
//     <span className={`fs-14 ${isActive ? "text-primary" : "text-muted"}`}>
//       {icon}
//     </span>
//     <span
//       className={`fs-10 fw-semibold ${
//         isActive ? "text-primary" : "text-muted"
//       } text-nowrap`}
//     >
//       {title}
//     </span>
//   </Flex>
// );

const EligibilityResponseContainer = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { eligibilityCheckData } = useSelector(
    (state) => state.eligibilityCheck
  );
  const { allPermissionType } = useSelector((state) => state.role);
  const eligibilitySetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Eligibility"
  );

  // Extract ID safely from URL param
  const urlEligibilityId = typeof id === "string" ? id.split("_").pop() : "";

  // Extract ID safely from Redux data
  const fullEligibilityId = eligibilityCheckData?.eligibilityid;
  const checkID =
    typeof fullEligibilityId === "string"
      ? fullEligibilityId.split("_").pop()
      : "";

  // Choose the available one
  const finalEligibilityId = checkID || urlEligibilityId;
  const fullEligibilityIdForQuery = fullEligibilityId || id;

  const [activeKey, setActiveKey] = useState("payer_response");

  const handleSubmitPreauthorization = async () => {
    try {
      const response = await dispatch(
        GetSingleEligibilityData(fullEligibilityIdForQuery)
      ).unwrap();

      if (response?.success) {
        navigate(
          `${paths.preauthorization}?preauthid=${fullEligibilityIdForQuery}&eligibility=true`
        );
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      console.error("Preauthorization fetch failed:", error);
      toast.error("Failed to create preauthorization.");
    }
  };

  return (
    <Card className="position-relative mt-3">
      <Tab.Container
        id="top-course-tab"
        activeKey={activeKey}
        onSelect={(k) => setActiveKey(k)}
      >
        <Card.Header className="d-flex align-items-center justify-content-between">
          <Nav variant="tabs" className="border-0 d-flex align-items-center ">
            {id && (
              <Button
                variant="secondary"
                className="me-3"
                size="sm"
                onClick={() => navigate(-1)}
              >
                <ArrowLeft size={18} />
              </Button>
            )}
            <Nav.Item>
              <Nav.Link
                eventKey="payer_response"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <PersonBadge /> Payer Response
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="benefit_tables"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <Table /> Benefits table
              </Nav.Link>
            </Nav.Item>
          </Nav>

          {eligibilityCheckData?.eligibility_status?.toLowerCase() ===
            "eligible" &&
            Number(eligibilitySetting?.submit) === 1 && (
              <div>
                <Button
                  onClick={handleSubmitPreauthorization}
                  variant="primary"
                  size="sm"
                  className="w-100 w-md-auto text-nowrap"
                >
                  <Send className="me-2" />
                  Create Preauthorization
                </Button>
              </div>
            )}
        </Card.Header>

        <Card.Body className="p-0 m-0">
          <Tab.Content>{children}</Tab.Content>
        </Card.Body>
      </Tab.Container>
    </Card>
  );
};

EligibilityResponseContainer.propTypes = {
  children: PropTypes.node,
};

export default EligibilityResponseContainer;
